import React from 'react';
import FontAwesome from 'react-fontawesome';
import { NavLink, withRouter } from 'react-router-dom';

import EmmaNewsletterForm from 'components/global/application/EmmaNewsletterForm';
import Expandable from 'components/global/application/Expandable';
import { DispatchProps, StateProps } from 'components/pages/brand/BrandsInfo';
import { BREAK_POINT } from 'constants/responsive';
import AboutDropMenu from './AboutDropMenu';
import AccessoryDropMenu from './AccessoryDropMenu';
import InventoryDropMenu from './InventoryDropMenu';
import NewArrivalsDropMenu from './NewArrivalsDropMenu';
import ResourceDropMenu from './ResourceDropMenu';

import Product from 'types/shopify/Product';

import slugify from 'slugify';

import './Nav.sass';

// v-- container component which encapsulates all nav functionality --v
export interface INavReduxProps {
    shopifyCollectionsLoading: boolean;
    shopifyCollections: any; // TODO - Fix any
    accessoriesMenuTypes: any;
}

export interface INavDispatchProps {
    getShopifyCollections: any; // TODO - Fix Any
}
export interface INavProps {
    isOpen?: boolean;       // Mobile only; nav doesn't display until menu button clicked
    menuProducts: Product[];
    menuProductsLoading: boolean;
    closeHandler?(): void;  // ^ -- same, but nav needs to be able to close itself too
}

// Not sure on what the best name on this should be or what convention to use right now
export type NavProps = INavProps & INavReduxProps & INavDispatchProps & DispatchProps & StateProps;

interface INavState {
    accessoriesHovered: boolean;
    activeItem: string;
    dropDownHovered: boolean;   // Desktop only, used in deciding when to clear activeItem
    showNewsLetterForm: boolean;
}

class Nav extends React.Component<NavProps, INavState> {
    constructor(props: NavProps) {
        super(props);
        this.state = {
            accessoriesHovered: false,
            activeItem: '',
            dropDownHovered: false,
            showNewsLetterForm: false,
        };

        this.props.getShopifyCollections();
        this.props.loadBrandsInfo();
        // I don't think we need to use .bind(this) below since these functions are arrow functions?
        this.renderDesktop = this.renderDesktop.bind(this);
        this.renderMobile = this.renderMobile.bind(this);
        this.navHovered = this.navHovered.bind(this);
        this.navUnHovered = this.navUnHovered.bind(this);
        this.navArrowClicked = this.navArrowClicked.bind(this);
        this.newsLetterShowToggle = this.newsLetterShowToggle.bind(this);
        this.onNavClosed = this.onNavClosed.bind(this);
    }

    public render() {
        return window.innerWidth < BREAK_POINT ? this.renderMobile() : this.renderDesktop();
    }

    // v-- Mobile only --v
    public navArrowClicked = (event: React.MouseEvent<any>): void => {
        this.state.activeItem === event.currentTarget.id
            ? this.setState({ activeItem: '' })
            : this.setState({ activeItem: event.currentTarget.id });
    }

    public onNavClosed = () => {
        this.setState({ activeItem: '' }, this.props.closeHandler);
    }

    public newsLetterShowToggle = () => {
        this.setState({ showNewsLetterForm: !this.state.showNewsLetterForm });
    }
    // ^-- Mobile only --^

    // v-- Desktop only --v
    public navHovered  = (event: React.MouseEvent<any>): void => {
        if (event.currentTarget.id !== 'submenu') this.setState({ activeItem: event.currentTarget.id });
    }

    public navUnHovered = (event: React.MouseEvent<any>): void => {
        if (!this.state.dropDownHovered) this.setState({ activeItem: '' });
    }

    public dropMenuHovered = (event: React.MouseEvent<any>): void => {
        this.setState({ dropDownHovered: true });
    }

    public dropMenuUnHovered = (event: React.MouseEvent<any>): void => {
        this.setState({
            activeItem: '',
            dropDownHovered: false
        });
    }

    public accessoryMenuToggle = (hoverEvent: React.MouseEvent<any>, toggled: boolean) => {
        if (toggled) {
            this.setState({
                accessoriesHovered: true,
                activeItem: 'accessories',
            });
        } else {
            this.setState({
                accessoriesHovered: false,
                activeItem: '',
            });
        }
    }
    // ^-- Desktop only --^

    public renderDesktop = () => {
        return(
            <div className="row App-nav">
                <div className="offset-1 col-10">
                    <ul className="nav nav-fill justify-content-center" onMouseLeave={this.navUnHovered} >
                        {/* TODO: Abstract boilerplate below */}
                        <li className="nav-item Nav-category" onMouseEnter={this.navHovered} >
                            <NavLink exact to="/">Home</NavLink>
                        </li>
                        {/* <li className="nav-item Nav-category highlighted" onMouseEnter={this.navHovered} >
                            <NavLink exact to="/new-arrivals">New Arrivals</NavLink>
                        </li> */}
                        <li className={`nav-item Nav-category${this.state.activeItem === 'newarrivals' ? '-hovered' : ''}`} id="newarrivals" onMouseEnter={this.navHovered}>
                            <NavLink to="/new-arrivals/">New Arrivals</NavLink> <FontAwesome name="caret-down" className="Nav-arrow" />
                            <NewArrivalsDropMenu showing={this.state.activeItem === 'newarrivals'} mouseHovered={this.dropMenuHovered} mouseUnHovered={this.dropMenuUnHovered} />
                        </li>
                        <li className="DropMenu-positioner">
                            {/* Menu goes here for alignment */}
                            <InventoryDropMenu brands={this.props.brands} showing={this.state.activeItem === 'inventory'} mouseHovered={this.dropMenuHovered} mouseUnHovered={this.dropMenuUnHovered} />
                        </li>
                        <li className={`nav-item Nav-category${this.state.activeItem === 'inventory' ? '-hovered' : ''}`} id="inventory" onMouseEnter={this.navHovered}>
                            <NavLink to="/inventory">Instruments & Amps</NavLink> <FontAwesome name="caret-down" className="Nav-arrow" />
                        </li>
                        <li className={`nav-item Nav-category${this.state.activeItem === 'accessories' ? '-hovered' : ''}`} id="accessories" onMouseEnter={this.navHovered}>
                            <NavLink to="/accessories">Accessories</NavLink> <FontAwesome name="caret-down" className="Nav-arrow" />
                            <AccessoryDropMenu
                                types={this.props.accessoriesMenuTypes}
                                collections={this.props.shopifyCollections}
                                showing={this.state.activeItem === 'accessories'}
                                mouseHovered={this.dropMenuHovered}
                                mouseUnHovered={this.dropMenuUnHovered}
                            />
                        </li>
                        <li className="nav-item Nav-category" onMouseEnter={this.navHovered} >
                            <a href="/appraisals">Appraisals</a>
                        </li>
                        <li className={`nav-item Nav-category${this.state.activeItem === 'resource_center' ? '-hovered' : ''}`} id="resource_center" onMouseEnter={this.navHovered}>
                            <NavLink to="/news">Resource Center</NavLink> <FontAwesome name="caret-down" className="Nav-arrow" />
                            <ResourceDropMenu showing={this.state.activeItem === 'resource_center'} mouseHovered={this.dropMenuHovered} mouseUnHovered={this.dropMenuUnHovered} />
                        </li>
                        <li className={`nav-item Nav-category${this.state.activeItem === 'about' ? '-hovered' : ''}`} id="about" onMouseEnter={this.navHovered}>
                            <NavLink to="/gruhn-guitars-story/">About Us</NavLink> <FontAwesome name="caret-down" className="Nav-arrow" />
                            <AboutDropMenu showing={this.state.activeItem === 'about'} mouseHovered={this.dropMenuHovered} mouseUnHovered={this.dropMenuUnHovered} />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    public renderMobile = () => {
        if (!this.props.closeHandler) {
            return null;
        }
        return(
            <Expandable className="App-nav-mobile" expanded={this.props.isOpen} direction="both" maxHeight="700px" maxWidth="80%">
                <EmmaNewsletterForm isOpen={this.state.showNewsLetterForm} onRequestClose={this.newsLetterShowToggle} isMobile={true} />
                <ul className="nav flex-column">
                    <li className="nav-item Nav-category" onClick={this.onNavClosed}><span className="Close-x">X</span>Close</li>
                    <li className="nav-item Nav-category"><NavLink exact onClick={this.onNavClosed} to="/">Home</NavLink></li>
                    <li className="nav-item Nav-category"><NavLink exact onClick={this.onNavClosed} to="/new-arrivals">New Arrivals</NavLink></li>
                    <li className="nav-item Nav-category"><NavLink exact onClick={this.onNavClosed} to="/vintage-new-arrivals">Vintage New Arrivals</NavLink></li>
                    <li className="nav-item Nav-category"><NavLink exact onClick={this.onNavClosed} to="/inventory/vintage">Vintage Instruments</NavLink></li>
                    <li className="nav-item Nav-category">
                        <NavLink onClick={this.onNavClosed} to="/inventory">Instruments &amp; Amps</NavLink>
                        <FontAwesome name={`chevron-${this.state.activeItem === 'inventory' ? 'down' : 'right' }`} className="Nav-arrow" id="inventory" onClick={this.navArrowClicked} />
                        <Expandable expanded={this.state.activeItem === 'inventory'} direction="vertical" maxHeight="220px">
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/acoustic-guitars">Acoustic Guitars</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/electric-guitars">Electric Guitars</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/mandolins-and-mandolin-family">Mandolins And Mandolin Family</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/banjos">Banjos</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/resonator-guitars">Resonator Instruments</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/ukuleles-taropatches-and-tiples">Ukuleles, Taropatches, and Tiples</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/tenor-and-plectrum-guitars">Tenor and Plectrum Guitars</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/basses">Basses</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/amplifiers">Amplifiers</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/miscellaneous-instruments">Misc Instruments</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory?memorabilia=true">Memorabilia</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/inventory/category/cases">Cases</NavLink>
                        </Expandable>
                    </li>
                    <li className="nav-item Nav-category"><NavLink exact onClick={this.onNavClosed} to="/brands">Our Brands</NavLink></li>
                    <li className="nav-item Nav-category">
                        <NavLink onClick={this.onNavClosed} to="/accessories">Accessories</NavLink>
                        <FontAwesome name={`chevron-${this.state.activeItem === 'accessories' ? 'down' : 'right' }`} className="Nav-arrow" id="accessories" onClick={this.navArrowClicked} />
                        <Expandable expanded={this.state.activeItem === 'accessories'} direction="vertical" maxHeight="220px">
                            {
                                this.props.accessoriesMenuTypes ? this.props.accessoriesMenuTypes.map((type: any, i: number) => {
                                    return (
                                        <NavLink key={'mobile-accessories-sub-menu-' + i}className="Nav-sub-category" onClick={this.onNavClosed} exact to={'/accessories/type/' + slugify(type)}>
                                            {type}
                                        </NavLink>
                                    );
                                }) : null
                            }
                        </Expandable>
                    </li>
                    <li className="nav-item Nav-category">
                        <a href="/appraisals">Appraisals</a>
                    </li>
                    <li className="nav-item Nav-category">
                        <NavLink onClick={this.onNavClosed} to="/news/">Resource Center</NavLink>
                        <FontAwesome name={`chevron-${this.state.activeItem === 'resource_center' ? 'down' : 'right' }`} className="Nav-arrow" id="resource_center" onClick={this.navArrowClicked} />
                        <Expandable expanded={this.state.activeItem === 'resource_center'} direction="vertical" maxHeight="170px">
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/news">News & Events</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/vintage-guitars">Vintage Guitar Magazine Articles</NavLink>
                            <a className="Nav-sub-category" href="/archived-inventory">Archived Guitars</a>
                        </Expandable>
                    </li>
                    <li className="nav-item Nav-category">
                        <NavLink onClick={this.onNavClosed} to="/store-policies/">About Us</NavLink>
                        <FontAwesome name={`chevron-${this.state.activeItem === 'about' ? 'down' : 'right' }`} className="Nav-arrow" id="about" onClick={this.navArrowClicked} />
                        <Expandable expanded={this.state.activeItem === 'about'} direction="vertical" maxHeight="170px">
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/store-policies/">Store Policies</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/gruhn-guitars-staff">Gruhn Staff</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/repair-shop">Repair Shop</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/users/george">George Gruhn Bio</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/gruhn-guitars-story">Gruhn Guitars History</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/store-tour">Store Tour</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/videos">Videos</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/news">News</NavLink>
                            <NavLink className="Nav-sub-category" exact onClick={this.onNavClosed} to="/want-file">Want File</NavLink>
                        </Expandable>
                    </li>
                    <li className="nav-item Nav-category"><NavLink exact onClick={this.onNavClosed} to="/contactdirections/">Contact Us</NavLink></li>
                    <li className="nav-item text-center Nav-category">
                        <span>Connect with Us</span>
                        <br />
                        <a target="_blank" href="https://www.facebook.com/gruhnguitars"><FontAwesome className="Nav-icon" name="facebook-square" /></a>
                        <a target="_blank" href="https://www.instagram.com/gruhnguitars/"><FontAwesome className="Nav-icon" name="instagram" /></a>
                        <a target="_blank" href="https://twitter.com/gruhnguitars"><FontAwesome className="Nav-icon" name="twitter-square" /></a>
                        <a target="_blank" href="https://www.youtube.com/user/gruhnguitarsinc"><FontAwesome className="Nav-icon" name="youtube-play" /></a>
                        <br />
                        <a className="header phone" href="tel:615-256-2033">615-256-2033</a>
                    </li>
                </ul>
            </Expandable>
        );
    }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/global/application/nav/Nav.tsx